export const SERVICE_CODE = 'LOGGER' + '_SERVICE';
